import { ensureResolvedWebsiteUrl } from "@/lib/websiteUrls"

import type { ILinkOpenerService } from "./types"

export const LinkOpenerService: ILinkOpenerService = {
  async openUrl(url: string) {
    globalThis.location.assign(ensureResolvedWebsiteUrl(url))
    return { didOpenBrowser: false }
  },

  async redirect(url: string) {
    globalThis.location.assign(url)
  },
}
